import { styled } from 'naan/stitches.config';

export const AuthHeading = styled('header', {
  textStyle: 'large-heading--responsive',
  textAlign: 'center',
  margin: '0 0 40px 0',
});
